import { hex2oklch, hex2rgb } from "colorizr";
import { TEXT_COLOR } from "shared/consts";

export const getContrastColor = (hexColor: string) => {
  if (!hexColor) return TEXT_COLOR;

  const lightness = hex2oklch(hexColor).l;

  return lightness >= 0.75 ? TEXT_COLOR :'#fff';
}

export const getOpacityColor = (hexColor: string, opacity: number | string) => {
  const rgba = hex2rgb(hexColor);

  return `rgba(${rgba.r},${rgba.g},${rgba.b}, ${opacity})`
}